module.exports = __webpack_public_path__ + "static/media/CTLI_11-293w.74c9546a.png";